module.exports = __webpack_public_path__ + "static/media/greg-error.d6fb1a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/greg-error.png
// module id = 3528
// module chunks = 0